import { RowRechargerDto } from "@/dtos";
import { Recharger } from "@/entities";
import { getRechargerTypeLabel } from "@/helpers/options";
import { formatToCurrency } from "@/helpers/utilities";

export const formatRowRechargerDto = (rechargers: Recharger[]): RowRechargerDto[] => {
    return rechargers.map(x => {
        const row: RowRechargerDto = {
            ...x,
            device: x.rechargerDetails.device,
            type_label: getRechargerTypeLabel(x.type),
            company: x.rechargerDetails.company,
            site_label: x.site.name,
            balance_label: `$ ${formatToCurrency(x.balance)}`,
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}